import React from 'react'
import {
    BrowserRouter,
    Route,
    Routes,
  } from "react-router-dom";
import ScrollToTop from '../components/ScrollTo/ScrollTo';
import Article from '../pages/Article/Article';
import Home from '../pages/Home/Home';
import League from '../pages/League/League';
import Login from '../pages/Login/Login';
import NotFound from '../pages/NotFound/NotFound';
import Search from '../pages/Search/Search';
import Tag from '../pages/Tag/Tag';
import HomeArticle from "../pages/Admin/Home"
import CreateCustom from '../pages/CreateCustom/CreateCustom';
import EditCustom from '../pages/EditCustom/EditCustom';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import ArticleRead from '../pages/ArticleRead/ArticleRead';


const AllRoutes = () => {

    const router = [
        {
            path: "/",
            element: <Home />,
        },
        {
            path: "/article/:id",
            element: <Article />,
        },
        {
            path: "/article/:id/:fixture",
            element: <Article />,
        },
        {
            path: "/league/:id",
            element: <League />,
        },
        {
          path: "/search",
          element: <Search />,
        },
        {
            path: "/tag/:id",
            element: <Tag />,
        },
        {
          path: "/auth/article/login",
          element: <Login />,
        },
        {
          path: "/auth/article/resetpassword",
          element: <ResetPassword />,
        },
        {
          path: "/article/admin/:id",
          element: <Article admin={true} />,
        },
        {
          path: "/article/admin/:id/:fixture",
          element: <Article admin={true} />,
        },
        {
          path: "/article/create/admin/:id",
          element: <HomeArticle />,
        },
        {
          path: "/create-custom/admin/article",
          element: <CreateCustom />,
        },
        {
          path: "/edit-custom/admin/article/:id",
          element: <EditCustom />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
        {
          path: "/admin/articleread",
          element: <ArticleRead />
        },
    ];

  return (
    <div>
        <BrowserRouter>
          <Routes>
            {router.map((route) => (
              <Route key={route.path} path={route.path} element={route.element} />
            ))}
          </Routes>
          <ScrollToTop />
        </BrowserRouter>
        {/* <RouterProvider router={router} /> */}
    </div>
  )
}

export default AllRoutes